import { Helmet } from "react-helmet-async";
import { BUSINESS } from "../data/site";

export default function Seo({ title, description, path }) {
  const url = `${BUSINESS.domain}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
